$(document).ready(function () {
    'use strict';

    $('#agreed-modal-dialog input[type=submit]').click(function(){
        $('.upload-form input[type=checkbox]').prop('checked', true);
        $('#agreed-modal-dialog').modal('hide');
        $('.upload-form .btn-submit').prop('disabled', false);
    });

    $('#agreed-modal-dialog input[type=reset]').click(function(){
        $('.upload-form input[type=checkbox]').prop('checked', false);
        $('.upload-form .btn-submit').prop('disabled', true);
    });
});